import { computed } from "@vue/composition-api";
import { useTranslate } from "@lang";

// todo: use current language


type Config = {};

export const usePhrases = (c:Config = {}) => {

	const { translate } = useTranslate();

	const studyCloseMessage = computed(() => {
		// return STUDY_CLOSE_MESSAGE;
		return translate("studies.message.closingStudy");
	});

	const studyOpenMessage = computed(() => {
		// return STUDY_OPEN_MESSAGE;
		return translate("studies.message.openingStudy");

	});

	return {
		studyCloseMessage,
		studyOpenMessage
	};

};

// const STUDY_OPEN_MESSAGE = "This will start the study and allow more participants to join. Are you sure?";
// const STUDY_CLOSE_MESSAGE = "This will end the study and prevent more participants from joining. Are you sure?";
